export const appTitleOne = "THE ";
export const appTitleTwo = "BUNKER HOUSE";
export const bookingURL =
  "https://live.ipms247.com/booking/book-rooms-thebunkerhousecafeandstay";
